import {customElement} from 'aurelia-framework';

@customElement('spinner')
export class Spinner {

}
